import "./footer.scss"

export default function Footer() {
    return (
        <div className="footer">
            <div className="footNav">
                <div className="quickLinks">
                    <div className="title">
                        <p>Quick links</p>
                    </div>
                    <div className="menu">
                        <p>Home</p>
                        <p>Products</p>
                        <p>Contact Us</p>
                    </div>
                </div>
                <div className="others">
                    <div className="title">
                        <p>Others</p>
                    </div>
                    <div className="menu">
                        <p>Documentation</p>
                        <p>Medium</p>
                    </div>
                </div>
                <div className="emailAddress">
                    <div className="title">
                        <p>Email Address</p>
                    </div>
                    <div className="menu">
                        <p>nok@nokheads.com</p>
                    </div>
                </div>
                <div className="socialLinks">
                    <div className="title">
                        <p>Social Media</p>
                    </div>
                    <div className="menu">
                        <div className="socialIcon"><a href="https://discord.gg/rEebfHCsxH"><i className="fab fa-discord"/></a></div>
                        <div className="socialIcon"><a href="https://nokheads.medium.com/"><i className="fab fa-medium-m"/></a></div>
                        <div className="socialIcon"><a href="https://twitter.com/nokheads"><i className="fab fa-twitter"/></a></div>
                    </div>
                </div>
            </div>
        </div>
    )
}
